import React from 'react';
import { Media } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';

const renderEquipmentOption = (e) => (
  <span>
    <FontAwesome name="square" style={{ color: e.color || '#fafafa' }} /> {e.name}
  </span>
);

const filterOption = (option, filterString) =>
  option.name.toLocaleLowerCase().indexOf(filterString.toLocaleLowerCase()) >= 0;

const EquipmentEdit = ({ crew, equipment, onChange }) => (
  <Media>
    <Media.Left>
      <FontAwesome name="truck" />
    </Media.Left>
    <Media.Body>
      <Media.Heading>Equipment</Media.Heading>
      <Select
        filterOption={filterOption}
        labelKey="name"
        optionRenderer={renderEquipmentOption}
        options={equipment}
        onChange={onChange}
        value={crew && crew.equipment ? crew.equipment.id : null}
        valueKey="id"
        valueRenderer={renderEquipmentOption}
      />
    </Media.Body>
  </Media>
);

export default EquipmentEdit;
